import React, { useEffect } from 'react';
import { Form, Select, Space, Button, Switch, Radio, Input, Popconfirm, Tooltip } from 'antd';
import {
  QuestionCircleOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons';

interface PropsType {
  onChange?: any,
  value?: any,
  enums?: any,
  useInput?: Boolean,
}

const FIELD_KEY = 'contact_info_encrypt';

const SPContact: React.FC<PropsType> = (props) => {
  const { enums, onChange, value, useInput } = props
  const form = Form.useFormInstance();

  const [emergencyCode, setEmergencyCode] = React.useState(0);

  // //TODO:监听文本框，禁止输入回车和空格
  // const onKeydown = (e: any) => {
  //     if(e.keyCode === 32 || e.keyCode === 13){
  //         e.preventDefault();
  //         return;
  //     }
  // };

  //初始化赋值Form.list,如果value为空则初始化一项空数据
  useEffect(() => {
    if(value){
      form.setFieldsValue({ [FIELD_KEY]: value })
      setEmergencyCode(value.findIndex((item: any) => item.emergency))
    }else{
      form.setFieldsValue({contact_info_encrypt:[{contact: '', emergency: true}]})
    }
  }, [])

  return (
    <>
      <Form.List name={FIELD_KEY}>
        {(fields, { add, remove, move }) => (
          <>
            {fields.map((field, index) => {
              return (
                <Space key={index} size={0} style={{marginRight: 10, width: '100%'}}>
                    <Form.Item style={{ marginBottom: 16 }} {...field} name={[field.name, 'contact']} validateTrigger="onBlur" rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value) {
                            return Promise.reject(new Error('请输入联系方式'));
                          }
                          if (!/^1[3456789]\d{9}$|((\d{3,4}-)?[0-9]{7,8})$/.test(value)) {
                            return Promise.reject(new Error('联系方式格式错误'));
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}>
                      { useInput
                        ? <Input placeholder="请输入手机号码" style={{ width: 200 }} />
                        : <Select placeholder="请选择员工作为门店联系人" options={enums} fieldNames={{label:'value', value:'key'}} style={{ width: 200 }} />
                      }
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 16 }} name={[field.name, 'emergency']} rules={[{ required:false }]} label="">
                      <Radio style={{ marginLeft: 12 }} checked={emergencyCode === index} onChange={(e)=>{
                        if(e.target.checked){
                          setEmergencyCode(index)
                          form.setFieldsValue({ [FIELD_KEY]: form.getFieldValue(FIELD_KEY).map((item: any, i: number) => {
                            return { contact: item.contact, emergency: i === index }
                          })})
                        }
                      }}>设置为紧急联系人</Radio>
                    </Form.Item>
                  <Form.Item style={{ marginBottom: 16 }}>
                    {fields.length > 1 &&
                      <Popconfirm
                        title="确认删除当前联系方式吗?"
                        onConfirm={() => {
                          if (emergencyCode === index) {
                            setEmergencyCode(0)
                          }
                          remove(field.name)
                        }}
                        okText="确认"
                        cancelText="取消"
                      >
                        <Button type="link" icon={<DeleteOutlined />} style={{ padding: '4px 0', marginRight: 12 }}>删除</Button>
                      </Popconfirm>
                    }
                    <Tooltip title="座机号输入格式：需要输入区号及电话号码，区号与电话号码中间用“-”隔开（英文中横杠）例如：010-1234567">
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </Form.Item>
                </Space>
              )
            })}
            <Button type="link" style={{ padding: 0, height: 28 }} icon={<EditOutlined />} onClick={() => { if (fields.length < 6) add({}) }}>增加</Button>
          </>
        )}
      </Form.List>
    </>
  );
};

export default SPContact;
